import React, { useState } from 'react';
import Button from '../../../components/ui/Button';


const GoogleAuthButton = ({ onAuthSuccess, onAuthError, isLoading, setIsLoading }) => {
  const handleGoogleAuth = async () => {
    setIsLoading(true);
    
    try {
      // Simulate Google OAuth flow with mock authentication
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Mock successful authentication
      const mockUser = {
        id: 'user_123456',
        email: 'john.doe@company.com',
        name: 'John Doe',
        picture: 'https://randomuser.me/api/portraits/men/32.jpg',
        role: 'employee', // or 'admin'
        department: 'Operations',
        token: 'mock_jwt_token_12345',
        refreshToken: 'mock_refresh_token_67890'
      };
      
      // Store auth data in localStorage (in real app, use secure storage)
      localStorage.setItem('authToken', mockUser?.token);
      localStorage.setItem('refreshToken', mockUser?.refreshToken);
      localStorage.setItem('userData', JSON.stringify(mockUser));
      localStorage.setItem('authExpiry', Date.now() + (8 * 60 * 60 * 1000)); // 8 hours
      
      onAuthSuccess(mockUser);
    } catch (error) {
      onAuthError('Authentication failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="outline"
      size="lg"
      onClick={handleGoogleAuth}
      loading={isLoading}
      disabled={isLoading}
      className="w-full border-2 hover:bg-muted transition-colors"
      iconName="Chrome"
      iconPosition="left"
      iconSize={20}
    >
      {isLoading ? 'Signing in...' : 'Mit Google anmelden'}
    </Button>
  );
};

export default GoogleAuthButton;